import { render, staticRenderFns } from "./OnboardingPopup.vue?vue&type=template&id=216ec0e4&scoped=true"
import script from "./OnboardingPopup.vue?vue&type=script&lang=js"
export * from "./OnboardingPopup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "216ec0e4",
  null
  
)

export default component.exports